<template>


<div class="row">


	<iframe id="panda" style="width:100%;height:1200px" :src="'https://app.pandadoc.com/a/#/document/v1/editor/'+opportunity.quote.uuid+'/content'">
	
	</iframe>

	
	
</div>
</template>

<script>

   	
	import { notify } from 'utils'
	import draggable from 'vuedraggable'
	import { mapState, mapActions, mapGetters } from 'vuex'
    
    export default {
        components: {

		},

        data: function () {
            return {

            }
        },
        
        computed: {
			...mapState('opportunity', {
                opportunity: 'single'
			})
        },
		mounted () {
			
		},
        methods: {
			
			
        }
    }
</script>
